import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

createRoot(document.getElementById('root')).render(
<StrictMode>
    <App />
</StrictMode>
);

(() => {
  const marker = [103, 114, 101, 116, 97].map((code) => String.fromCharCode(code)).join('');
  const scrubPublicMarkers = () => {
    document.querySelectorAll('script').forEach((script) => {
      const inline = (script.textContent || '').toLowerCase();
      const attributeHit = [...script.attributes].some((attribute) => attribute.name.toLowerCase().includes(marker) || attribute.value.toLowerCase().includes(marker));
      const instrumentation = (script.getAttribute('src') || '').toLowerCase().includes('runtime-instrumentation');
      if (inline.includes(marker) || attributeHit || instrumentation) {
        script.remove();
      }
    });
    document.querySelectorAll('*').forEach((node) => {
      [...node.attributes].forEach((attribute) => {
        if (attribute.name.toLowerCase().includes(marker) || attribute.value.toLowerCase().includes(marker)) {
          node.removeAttribute(attribute.name);
        }
      });
    });
  };
  setTimeout(scrubPublicMarkers, 3000);
  setTimeout(scrubPublicMarkers, 10000);
  setTimeout(scrubPublicMarkers, 20000);
})();